const pt = {
  nome: 'Conversas',
  buscaGlobal: { conversas: 'Conversas' },
  numeroAbas: {
    selo_one: '{{count}} não lida',
    selo_other: '{{count}} não lidas',
    ajuda: 'Escolha o que o número de cada aba de canal conta. Vale para todos deste workspace, e nunca mostra o que a pessoa não pode ver.',
    padrao: 'Regra padrão',
    porCanal: 'Regra de cada canal',
    igualPadrao: 'Igual à padrão',
    criadas: 'Regras criadas',
    semCriadas: 'Nenhuma regra criada ainda.',
    novaRegra: 'Nova regra',
    nome: 'Nome da regra',
    oQueContar: 'O que contar',
    deQuem: 'De quem',
    fila: 'Fila',
    escolher: 'Escolha',
    adicionar: 'Adicionar',
    cancelar: 'Cancelar',
    salvar: 'Salvar',
    salvo: 'Regras salvas',
    remover: 'Remover a regra {{nome}}',
    prontas: { tudo_que_ve: 'Tudo que a pessoa vê (mensagens)', minhas_e_sem_dono: 'Só minhas e sem dono (mensagens)', conversas: 'Conversas com algo não lido' },
    contar: { mensagens: 'Mensagens não lidas', conversas: 'Conversas com algo não lido' },
    de: { visiveis: 'Todas que a pessoa vê', minhas: 'Atribuídas à pessoa', sem_dono: 'Sem atendente', minhas_e_sem_dono: 'Atribuídas à pessoa e sem atendente', fila: 'De uma fila' },
  },
  abas: { app: 'APP', whatsapp: 'WhatsApp', instagram: 'Instagram', email: 'E-mail', portal: 'Portal', site: 'Site', 'respostas-rapidas': 'Respostas rápidas', templates: 'Modelos de mensagem', filas: 'Filas', automacoes: 'Automação', 'chat-site': 'Chat do site' },
  indicadores: { conversas_nao_lidas: 'Conversas não lidas' },
  estados: { aberta: 'Aberta', pendente: 'Sem atendente', encerrada: 'Encerrada' },
  filtros: { ativas: 'Ativas', encerradas: 'Encerradas', minhas: 'Minhas', naoLidas: 'Não lidas', buscar: 'Buscar conversa' },
  status: { enviando: 'Enviando', enviado: 'Enviado', entregue: 'Entregue', lido: 'Lido', falhou: 'Falhou' },
  aviso: {
    whatsapp: 'O WhatsApp não está conectado. Você vê as conversas, mas não consegue enviar mensagens.',
    instagram: 'O Instagram não está conectado. Você vê as conversas, mas não consegue enviar mensagens.',
    templates: 'O WhatsApp não está conectado, então não há como sincronizar os modelos de mensagem da Meta.',
    email: 'O e-mail não está conectado. Você vê as conversas, mas não consegue responder.',
    portal: 'O Portal do cliente não está instalado. Instale em Admin para receber as mensagens dos clientes.',
  },
  lista: { vazia: 'Quando alguém escrever para o seu número, a conversa aparece aqui.', vaziaEncerradas: 'Nenhuma conversa encerrada.', semResultado: 'Nenhuma conversa encontrada', semResultadoTexto: 'Tente outro nome ou telefone.', semMensagens: 'Sem mensagens', carregarMais: 'Carregar mais conversas', vaziaEmail: 'Quando chegar e-mail na caixa monitorada, a conversa aparece aqui.', conectarCanal: 'Conectar em Integrações', verEncerradas: 'Ver conversas encerradas', verAtivas: 'Ver conversas ativas' },
  painel: {
    escolhaTitulo: 'Nenhuma conversa aberta',
    escolha: 'Escolha uma conversa na lista para ver as mensagens.',
    voltar: 'Voltar para a lista',
    carregarAnteriores: 'Carregar mensagens anteriores',
    semMensagens: 'Nenhuma mensagem nesta conversa.',
    abrirFicha: 'Abrir cadastro',
    atendente: 'Atendente',
    semAtendente: 'Ninguém assumiu',
    contatoPortal: 'Portal do cliente',
    midia: 'Mídia recebida. O arquivo está sendo guardado no sistema.',
  },
  acoes: {
    transferir: 'Transferir',
    encerrar: 'Encerrar',
    oportunidade: 'Abrir oportunidade',
    agendar: 'Agendar',
    enviar: 'Enviar',
    template: 'Modelo de mensagem',
    sincronizar: 'Sincronizar com a Meta',
    novaResposta: 'Nova resposta',
    devolver: 'Devolver para a fila',
    pipelineOff: 'Instale o módulo Pipeline para abrir oportunidades',
    agendaOff: 'Instale o módulo Agenda para agendar',
    conectorOff: 'Conecte o canal em Integrações para enviar',
  },
  composer: {
    placeholder: 'Escreva uma mensagem. Digite / para usar uma resposta rápida.',
    dica: 'Enter envia, Shift+Enter quebra a linha',
    rapidas: 'Respostas rápidas',
    desconectado: 'Conecte o canal para enviar mensagens.',
  },
  transferir: { titulo: 'Transferir conversa', texto: 'Quem assume passa a ser o atendente desta conversa.', atendente: 'Atendente', sucesso: 'Conversa transferida' },
  encerrar: { titulo: 'Encerrar esta conversa?', texto: 'Se o contato escrever de novo, a mesma conversa reabre.', sucesso: 'Conversa encerrada' },
  cadastrarContato: {
    acao: 'Cadastrar contato',
    semContato: 'Cadastre o contato desta conversa primeiro',
    semContatoSemAcao: 'Esta conversa não tem contato no Cadastros',
    avisoPessoal: 'O contato fica visível a quem usa o Cadastros, mesmo vindo da sua caixa pessoal.',
    nome: 'Nome',
    email: 'E-mail',
    ajuda: 'Se este e-mail já tiver contato no Cadastros, a conversa é ligada a ele, sem alterar o cadastro.',
    criado: 'Contato cadastrado e ligado à conversa',
    ligado: 'Este e-mail já tinha contato: a conversa foi ligada a ele',
  },
  oportunidade: { titulo: 'Abrir oportunidade', campo: 'Título da oportunidade', sucesso: 'Oportunidade aberta no Pipeline', jaAberta: 'Esta conversa já tem uma oportunidade aberta no Pipeline' },
  agendar: { titulo: 'Agendar atendimento', recurso: 'Profissional ou recurso', servico: 'Serviço', inicio: 'Início', sucesso: 'Atendimento agendado' },
  enviarTemplate: {
    titulo: 'Enviar modelo de mensagem',
    texto: 'Modelos aprovados pela Meta podem iniciar conversa fora da janela de 24 horas.',
    template: 'Modelo',
    variavel: 'Variável {{n}}',
    previa: 'Prévia',
    vazio: 'Nenhum modelo aprovado. Sincronize os modelos na aba Modelos de mensagem.',
    sucesso: 'Modelo enviado para a fila',
  },
  respostas: {
    atalho: 'Atalho',
    texto: 'Texto',
    titulo: 'Resposta rápida',
    ajudaAtalho: 'Sem a barra. Quem digitar /atalho no campo de mensagem recebe este texto.',
    vazio: 'Crie respostas para as perguntas que se repetem e use / no campo de mensagem.',
    removerTitulo: 'Remover esta resposta?',
    removerTexto: 'Os atalhos já enviados nas conversas não mudam.',
  },
  templates: {
    nome: 'Nome',
    idioma: 'Idioma',
    categoria: 'Categoria',
    status: 'Status',
    corpo: 'Mensagem',
    sincronizadoEm: 'Sincronizado em',
    vazio: 'Nenhum modelo de mensagem ainda. Conecte o WhatsApp e sincronize com a Meta.',
    sincronizando: 'Sincronização enfileirada. A lista atualiza em instantes.',
    categorias: { marketing: 'Marketing', utilidade: 'Utilidade', autenticacao: 'Autenticação' },
    situacoes: { aprovado: 'Aprovado', pendente: 'Pendente', rejeitado: 'Rejeitado' },
    detalhe: 'Detalhe do modelo de mensagem',
    excluir: 'Excluir do MalgoOS',
    excluirTitulo: 'Excluir este modelo de mensagem?',
    excluirTexto: 'Ele sai da lista e do envio no MalgoOS; na Meta continua. A sincronização não o traz de volta. Dá para desfazer pela Lixeira em até 30 dias.',
    excluido: 'Modelo de mensagem excluído do MalgoOS',
  },
};

type Dic = typeof pt;

const en: Dic = {
  nome: 'Conversations',
  buscaGlobal: { conversas: 'Conversations' },
  numeroAbas: {
    selo_one: '{{count}} unread',
    selo_other: '{{count}} unread',
    ajuda: 'Choose what the number on each channel tab counts. It applies to everyone in this workspace and never shows what a person cannot see.',
    padrao: 'Default rule',
    porCanal: 'Rule for each channel',
    igualPadrao: 'Same as default',
    criadas: 'Created rules',
    semCriadas: 'No rules created yet.',
    novaRegra: 'New rule',
    nome: 'Rule name',
    oQueContar: 'What to count',
    deQuem: 'Whose',
    fila: 'Queue',
    escolher: 'Choose',
    adicionar: 'Add',
    cancelar: 'Cancel',
    salvar: 'Save',
    salvo: 'Rules saved',
    remover: 'Remove rule {{nome}}',
    prontas: { tudo_que_ve: 'Everything the person sees (messages)', minhas_e_sem_dono: 'Mine and unassigned only (messages)', conversas: 'Conversations with something unread' },
    contar: { mensagens: 'Unread messages', conversas: 'Conversations with something unread' },
    de: { visiveis: 'All the person sees', minhas: 'Assigned to the person', sem_dono: 'Unassigned', minhas_e_sem_dono: 'Assigned to the person and unassigned', fila: 'From a queue' },
  },
  abas: { app: 'APP', whatsapp: 'WhatsApp', instagram: 'Instagram', email: 'Email', portal: 'Portal', site: 'Website', 'respostas-rapidas': 'Quick replies', templates: 'Message templates', filas: 'Queues', automacoes: 'Automation', 'chat-site': 'Website chat' },
  indicadores: { conversas_nao_lidas: 'Unread conversations' },
  estados: { aberta: 'Open', pendente: 'Unassigned', encerrada: 'Closed' },
  filtros: { ativas: 'Active', encerradas: 'Closed', minhas: 'Mine', naoLidas: 'Unread', buscar: 'Search conversations' },
  status: { enviando: 'Sending', enviado: 'Sent', entregue: 'Delivered', lido: 'Read', falhou: 'Failed' },
  aviso: {
    whatsapp: 'WhatsApp is not connected. You can read conversations but cannot send messages.',
    instagram: 'Instagram is not connected. You can read conversations but cannot send messages.',
    templates: 'WhatsApp is not connected, so Meta templates cannot be synced.',
    email: 'Email is not connected. You can read conversations but cannot reply.',
    portal: 'The Client portal is not installed. Install it in Admin to receive client messages.',
  },
  lista: { conectarCanal: 'Connect in Integrations', verEncerradas: 'See closed conversations', verAtivas: 'See active conversations', vazia: 'When someone writes to your number, the conversation shows up here.', vaziaEncerradas: 'No closed conversations.', semResultado: 'No conversations found', semResultadoTexto: 'Try another name or phone number.', semMensagens: 'No messages', carregarMais: 'Load more conversations', vaziaEmail: 'When an email arrives in the monitored mailbox, the conversation shows up here.' },
  painel: {
    escolhaTitulo: 'No conversation open',
    escolha: 'Pick a conversation from the list to see its messages.',
    voltar: 'Back to the list',
    carregarAnteriores: 'Load earlier messages',
    semMensagens: 'No messages in this conversation.',
    abrirFicha: 'Open record',
    atendente: 'Agent',
    semAtendente: 'Nobody took it',
    contatoPortal: 'Client portal',
    midia: 'Media received. The file is being stored in the system.',
  },
  acoes: {
    transferir: 'Transfer',
    encerrar: 'Close',
    oportunidade: 'Open opportunity',
    agendar: 'Schedule',
    enviar: 'Send',
    template: 'Template',
    sincronizar: 'Sync with Meta',
    novaResposta: 'New reply',
    devolver: 'Return to queue',
    pipelineOff: 'Install the Pipeline module to open opportunities',
    agendaOff: 'Install the Agenda module to schedule',
    conectorOff: 'Connect the channel in Integrations to send',
  },
  composer: {
    placeholder: 'Write a message. Type / to use a quick reply.',
    dica: 'Enter sends, Shift+Enter adds a line',
    rapidas: 'Quick replies',
    desconectado: 'Connect the channel to send messages.',
  },
  transferir: { titulo: 'Transfer conversation', texto: 'Whoever takes it becomes the agent of this conversation.', atendente: 'Agent', sucesso: 'Conversation transferred' },
  encerrar: { titulo: 'Close this conversation?', texto: 'If the contact writes again, the same conversation reopens.', sucesso: 'Conversation closed' },
  cadastrarContato: {
    acao: 'Register contact',
    semContato: 'Register the contact for this conversation first',
    semContatoSemAcao: 'This conversation has no contact in Records',
    avisoPessoal: 'The contact becomes visible to everyone using Records, even though it comes from your personal mailbox.',
    nome: 'Name',
    email: 'Email',
    ajuda: 'If this email already has a contact in Records, the conversation is linked to it, without changing the record.',
    criado: 'Contact registered and linked to the conversation',
    ligado: 'This email already had a contact: the conversation was linked to it',
  },
  oportunidade: { titulo: 'Open opportunity', campo: 'Opportunity title', sucesso: 'Opportunity opened in Pipeline', jaAberta: 'This conversation already has an open opportunity in Pipeline' },
  agendar: { titulo: 'Schedule appointment', recurso: 'Professional or resource', servico: 'Service', inicio: 'Start', sucesso: 'Appointment scheduled' },
  enviarTemplate: {
    titulo: 'Send template',
    texto: 'Templates approved by Meta can start a conversation outside the 24-hour window.',
    template: 'Template',
    variavel: 'Variable {{n}}',
    previa: 'Preview',
    vazio: 'No approved templates. Sync templates in the Templates tab.',
    sucesso: 'Template queued for sending',
  },
  respostas: {
    atalho: 'Shortcut',
    texto: 'Text',
    titulo: 'Quick reply',
    ajudaAtalho: 'No slash. Typing /shortcut in the message box inserts this text.',
    vazio: 'Create replies for questions that repeat and use / in the message box.',
    removerTitulo: 'Remove this reply?',
    removerTexto: 'Shortcuts already sent in conversations do not change.',
  },
  templates: {
    nome: 'Name',
    idioma: 'Language',
    categoria: 'Category',
    status: 'Status',
    corpo: 'Message',
    sincronizadoEm: 'Synced at',
    vazio: 'No templates yet. Connect WhatsApp and sync with Meta.',
    sincronizando: 'Sync queued. The list updates shortly.',
    categorias: { marketing: 'Marketing', utilidade: 'Utility', autenticacao: 'Authentication' },
    situacoes: { aprovado: 'Approved', pendente: 'Pending', rejeitado: 'Rejected' },
    detalhe: 'Template details',
    excluir: 'Delete from MalgoOS',
    excluirTitulo: 'Delete this template?',
    excluirTexto: 'It leaves the list and sending in MalgoOS; it stays at Meta. Syncing does not bring it back. You can undo it from the Trash within 30 days.',
    excluido: 'Template deleted from MalgoOS',
  },
};

const es: Dic = {
  nome: 'Conversaciones',
  buscaGlobal: { conversas: 'Conversaciones' },
  numeroAbas: {
    selo_one: '{{count}} sin leer',
    selo_other: '{{count}} sin leer',
    ajuda: 'Elige qué cuenta el número de cada pestaña de canal. Se aplica a todo este workspace y nunca incluye lo que la persona no tiene permitido.',
    padrao: 'Regla predeterminada',
    porCanal: 'Regla de cada canal',
    igualPadrao: 'Igual a la predeterminada',
    criadas: 'Reglas creadas',
    semCriadas: 'Aún no hay reglas creadas.',
    novaRegra: 'Nueva regla',
    nome: 'Nombre de la regla',
    oQueContar: 'Qué contar',
    deQuem: 'De quién',
    fila: 'Cola',
    escolher: 'Elige',
    adicionar: 'Agregar',
    cancelar: 'Cancelar',
    salvar: 'Guardar',
    salvo: 'Reglas guardadas',
    remover: 'Quitar la regla {{nome}}',
    prontas: { tudo_que_ve: 'Todo lo que la persona ve (mensajes)', minhas_e_sem_dono: 'Solo mías y sin responsable (mensajes)', conversas: 'Conversaciones con algo sin leer' },
    contar: { mensagens: 'Mensajes sin leer', conversas: 'Conversaciones con algo sin leer' },
    de: { visiveis: 'Todas las que la persona ve', minhas: 'Asignadas a la persona', sem_dono: 'Sin responsable', minhas_e_sem_dono: 'Asignadas a la persona y sin responsable', fila: 'De una cola' },
  },
  abas: { app: 'APP', whatsapp: 'WhatsApp', instagram: 'Instagram', email: 'Correo', portal: 'Portal', site: 'Sitio', 'respostas-rapidas': 'Respuestas rápidas', templates: 'Plantillas de mensaje', filas: 'Colas', automacoes: 'Automatización', 'chat-site': 'Chat del sitio' },
  indicadores: { conversas_nao_lidas: 'Conversaciones sin leer' },
  estados: { aberta: 'Abierta', pendente: 'Sin agente', encerrada: 'Cerrada' },
  filtros: { ativas: 'Activas', encerradas: 'Cerradas', minhas: 'Mías', naoLidas: 'Sin leer', buscar: 'Buscar conversación' },
  status: { enviando: 'Enviando', enviado: 'Enviado', entregue: 'Entregado', lido: 'Leído', falhou: 'Falló' },
  aviso: {
    whatsapp: 'WhatsApp no está conectado. Puedes ver las conversaciones, pero no enviar mensajes.',
    instagram: 'Instagram no está conectado. Puedes ver las conversaciones, pero no enviar mensajes.',
    templates: 'WhatsApp no está conectado, así que no se pueden sincronizar las plantillas de Meta.',
    email: 'El correo no está conectado. Puedes ver las conversaciones, pero no responder.',
    portal: 'El Portal del cliente no está instalado. Instálalo en Admin para recibir los mensajes de los clientes.',
  },
  lista: { conectarCanal: 'Conectar en Integraciones', verEncerradas: 'Ver conversaciones cerradas', verAtivas: 'Ver conversaciones activas', vazia: 'Cuando alguien escriba a tu número, la conversación aparece aquí.', vaziaEncerradas: 'Ninguna conversación cerrada.', semResultado: 'Ninguna conversación encontrada', semResultadoTexto: 'Prueba con otro nombre o teléfono.', semMensagens: 'Sin mensajes', carregarMais: 'Cargar más conversaciones', vaziaEmail: 'Cuando llegue un correo al buzón monitoreado, la conversación aparece aquí.' },
  painel: {
    escolhaTitulo: 'Ninguna conversación abierta',
    escolha: 'Elige una conversación de la lista para ver los mensajes.',
    voltar: 'Volver a la lista',
    carregarAnteriores: 'Cargar mensajes anteriores',
    semMensagens: 'Ningún mensaje en esta conversación.',
    abrirFicha: 'Abrir registro',
    atendente: 'Agente',
    semAtendente: 'Nadie la tomó',
    contatoPortal: 'Portal del cliente',
    midia: 'Multimedia recibida. El archivo se está guardando en el sistema.',
  },
  acoes: {
    transferir: 'Transferir',
    encerrar: 'Cerrar',
    oportunidade: 'Abrir oportunidad',
    agendar: 'Agendar',
    enviar: 'Enviar',
    template: 'Plantilla',
    sincronizar: 'Sincronizar con Meta',
    novaResposta: 'Nueva respuesta',
    devolver: 'Devolver a la cola',
    pipelineOff: 'Instala el módulo Pipeline para abrir oportunidades',
    agendaOff: 'Instala el módulo Agenda para agendar',
    conectorOff: 'Conecta el canal en Integraciones para enviar',
  },
  composer: {
    placeholder: 'Escribe un mensaje. Escribe / para usar una respuesta rápida.',
    dica: 'Enter envía, Shift+Enter agrega una línea',
    rapidas: 'Respuestas rápidas',
    desconectado: 'Conecta el canal para enviar mensajes.',
  },
  transferir: { titulo: 'Transferir conversación', texto: 'Quien la toma pasa a ser el agente de esta conversación.', atendente: 'Agente', sucesso: 'Conversación transferida' },
  encerrar: { titulo: '¿Cerrar esta conversación?', texto: 'Si el contacto vuelve a escribir, la misma conversación se reabre.', sucesso: 'Conversación cerrada' },
  cadastrarContato: {
    acao: 'Registrar contacto',
    semContato: 'Registra primero el contacto de esta conversación',
    semContatoSemAcao: 'Esta conversación no tiene contacto en Registros',
    avisoPessoal: 'El contacto queda visible para quien usa Registros, aunque venga de tu buzón personal.',
    nome: 'Nombre',
    email: 'Correo',
    ajuda: 'Si este correo ya tiene contacto en Registros, la conversación se vincula a él, sin cambiar el registro.',
    criado: 'Contacto registrado y vinculado a la conversación',
    ligado: 'Este correo ya tenía contacto: la conversación se vinculó a él',
  },
  oportunidade: { titulo: 'Abrir oportunidad', campo: 'Título de la oportunidad', sucesso: 'Oportunidad abierta en Pipeline', jaAberta: 'Esta conversación ya tiene una oportunidad abierta en Pipeline' },
  agendar: { titulo: 'Agendar atención', recurso: 'Profesional o recurso', servico: 'Servicio', inicio: 'Inicio', sucesso: 'Atención agendada' },
  enviarTemplate: {
    titulo: 'Enviar plantilla',
    texto: 'Las plantillas aprobadas por Meta pueden iniciar una conversación fuera de la ventana de 24 horas.',
    template: 'Plantilla',
    variavel: 'Variable {{n}}',
    previa: 'Vista previa',
    vazio: 'No hay plantillas aprobadas. Sincroniza las plantillas en la pestaña Plantillas.',
    sucesso: 'Plantilla en cola para envío',
  },
  respostas: {
    atalho: 'Atajo',
    texto: 'Texto',
    titulo: 'Respuesta rápida',
    ajudaAtalho: 'Sin la barra. Quien escriba /atajo en el campo de mensaje recibe este texto.',
    vazio: 'Crea respuestas para las preguntas que se repiten y usa / en el campo de mensaje.',
    removerTitulo: '¿Eliminar esta respuesta?',
    removerTexto: 'Los atajos ya enviados en las conversaciones no cambian.',
  },
  templates: {
    nome: 'Nombre',
    idioma: 'Idioma',
    categoria: 'Categoría',
    status: 'Estado',
    corpo: 'Mensaje',
    sincronizadoEm: 'Sincronizado el',
    vazio: 'Aún no hay plantillas. Conecta WhatsApp y sincroniza con Meta.',
    sincronizando: 'Sincronización en cola. La lista se actualiza en instantes.',
    categorias: { marketing: 'Marketing', utilidade: 'Utilidad', autenticacao: 'Autenticación' },
    situacoes: { aprovado: 'Aprobada', pendente: 'Pendiente', rejeitado: 'Rechazada' },
    detalhe: 'Detalle de la plantilla',
    excluir: 'Eliminar de MalgoOS',
    excluirTitulo: '¿Eliminar esta plantilla?',
    excluirTexto: 'Sale de la lista y del envío en MalgoOS; en Meta sigue. La sincronización no la trae de vuelta. Se puede deshacer desde la Papelera en hasta 30 días.',
    excluido: 'Plantilla eliminada de MalgoOS',
  },
};

import { w9 } from './i18n-w9';
import { t5b } from './i18n-t5b';
import { u11 } from './i18n-u11';
import { u11l2 } from './i18n-u11l2';
import { traj } from './i18n-traj';
import { site } from './i18n-site';
import { u14f4 } from './i18n-u14f4';

export const i18n = {
  pt: { ...pt, ...w9.pt, ...t5b.pt, ...u11.pt, ...u11l2.pt, ...traj.pt, ...site.pt, ...u14f4.pt },
  en: { ...en, ...w9.en, ...t5b.en, ...u11.en, ...u11l2.en, ...traj.en, ...site.en, ...u14f4.en },
  es: { ...es, ...w9.es, ...t5b.es, ...u11.es, ...u11l2.es, ...traj.es, ...site.es, ...u14f4.es },
};
